
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import CustomerHistory from "../components/customerHistory";
import Footer from "../components/footer";

function CustomerHistoryPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <CustomerHistory /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default CustomerHistoryPage;
